// extracted by mini-css-extract-plugin
export default {"endoflessonbox":"endoflesson_endoflessonbox__hdgqD","badge":"endoflesson_badge__BZvjJ"};